module.exports = __webpack_public_path__ + "img/labmemtest_text_nextbtn_en.82e5c588.png";